import { PortalMainLayout } from "../../components/layout/portal-main-layout";
import { AuthorisedPage } from "../auth/authorised-page";
import { ProfileForm } from "../../components/users/profile-form";

export const UserProfilePage = () => {
  return (
    <AuthorisedPage>
      <PortalMainLayout >
        <ProfileForm />
      </PortalMainLayout>
    </AuthorisedPage>
  );
};
